module.exports = __webpack_public_path__ + "static/img/counp4.de1576e6.png";